import Vue from 'vue';
import {Scrollbar, A11y, Keyboard} from "swiper/modules";

export default (el) =>
  new Vue({
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-swiper': () => import('../vue-swiper/vue-swiper.vue')
    },
    el,
    data: () => ({
      swiperOptions: {
        slidesPerView: 1.6,
        spaceBetween: 10,
        modules: [Scrollbar, Keyboard, A11y],
        a11y: true,
        keyboard: true,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
        breakpoints: {
          // when window width is >= 640px
          769: {
            slidesPerView: 2.4
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 12
          }
        }
      },
    }),
    mounted() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
  });
